// extracted by css-extract-rspack-plugin
export default {"BreadcrumbsView":"uWL3g"};